var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1641 41.4863V53.043C16.1641 53.7492 15.5846 54.327 14.8764 54.327C14.1682 54.327 13.5888 53.7492 13.5888 53.043V41.4863H16.1641Z",
    fill: "#4A567A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72587 49.1953H20.0271C20.7382 49.1953 21.3147 48.6204 21.3147 47.9112C21.3147 47.2021 20.7382 46.6272 20.0271 46.6272H9.72587C9.01472 46.6272 8.43822 47.2021 8.43822 47.9112C8.43822 48.6204 9.01472 49.1953 9.72587 49.1953Z",
    fill: "#4A567A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8765 18.6931C20.555 18.6931 25.1777 23.303 25.1777 28.9657C25.1777 34.6285 20.555 39.2383 14.8765 39.2383C9.19795 39.2383 4.57529 34.6285 4.57529 28.9657C4.57529 23.303 9.19795 18.6931 14.8765 18.6931ZM14.8765 16.125C7.76222 16.125 2 21.8776 2 28.9657C2 36.0538 7.76222 41.8064 14.8765 41.8064C21.9907 41.8064 27.7529 36.0602 27.7529 28.9657C27.7529 21.8712 21.9907 16.125 14.8765 16.125Z",
    fill: "#9BABD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8933 21.8962L60.9983 12.8164L59.1773 11.0005L50.0722 20.0802L51.8933 21.8962Z",
    fill: "#4A567A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4248 11.002H52.6304C51.9222 11.002 51.3428 11.5798 51.3428 12.286C51.3428 12.9923 51.9222 13.5701 52.6304 13.5701H58.4248V19.3484C58.4248 20.0546 59.0043 20.6325 59.7125 20.6325C60.4207 20.6325 61.0001 20.0546 61.0001 19.3484V11.002H58.4248Z",
    fill: "#4A567A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9795 18.6931C48.658 18.6931 53.2807 23.303 53.2807 28.9657C53.2807 34.6285 48.658 39.2383 42.9795 39.2383C37.301 39.2383 32.6783 34.6285 32.6783 28.9657C32.6783 23.303 37.301 18.6931 42.9795 18.6931ZM42.9795 16.125C35.8652 16.125 30.103 21.8712 30.103 28.9657C30.103 36.0602 35.8652 41.8064 42.9795 41.8064C50.0938 41.8064 55.856 36.0602 55.856 28.9657C55.856 21.8712 50.0938 16.125 42.9795 16.125Z",
    fill: "#9BABD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.c3e23df50b0e005f6733d8b6031d669e.svg";
export { ForwardRef as ReactComponent };